(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@tableau/widgets"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@tableau/widgets"], factory);
	else if(typeof exports === 'object')
		exports["DialogAPIContract"] = factory(require("react"), require("@tableau/widgets"));
	else
		root["DialogAPIContract"] = factory(root["React"], root["SharedWidgets"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
var widgets = __webpack_require__(2);
var DialogContractWidget = /** @class */ (function (_super) {
    __extends(DialogContractWidget, _super);
    function DialogContractWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogContractWidget.prototype.render = function () {
        var dialogProps = {
            testId: this.props.testId,
            isModal: this.props.isModal,
            // transparent by default to match Desktop behavior.
            isGlassTransparent: true,
            type: this.props.showTitleBar || this.props.showTitleBar === undefined
                ? widgets.DialogType.NormalWithTitleBar
                : widgets.DialogType.NormalWithoutTitleBar,
            showCloseButton: true,
            title: this.props.title,
            positioningBehavior: widgets.DialogPositioningBehavior.Draggable,
            shouldAdjustPositionOnWindowResize: true,
            zIndex: 988,
            dialogWidth: this.props.dialogWidth,
            showFooter: false,
            onCloseRequest: this.props.onCloseRequest,
            dialogBodyStyle: __assign({ overflow: 'visible' }, this.props.dialogBodyStyle),
            children: this.props.children
        };
        return React.createElement(widgets.DialogWidget, __assign({}, dialogProps));
    };
    return DialogContractWidget;
}(React.Component));
exports.DialogContractWidget = DialogContractWidget;
/**
 * @deprecated to be removed.
 */
var DialogWidget = /** @class */ (function (_super) {
    __extends(DialogWidget, _super);
    function DialogWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DialogWidget;
}(DialogContractWidget));
exports.DialogWidget = DialogWidget;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// @tableau/dialog-api-contract-web.min.js